import { createSelector } from 'reselect';

const selectScanCode = (state) => state.scanCode;

export const selectCodeScaned = createSelector(
  [selectScanCode],
  (scanCode) => scanCode.code
);
